import {Component} from '@angular/core';
import {select, Store} from '@ngrx/store';
import VideoState from '../shared/stores/root-store/video.state';
import {JumpToSceneAction, SetVideoStateTypeAction} from '../shared/stores/root-store/actions/video.action';
import {VideoStateEnum} from '../../enums/video-state.enum';
import {selectTotalTimeFromState, selectVideoScenesData} from '../shared/stores/root-store/selectors/video.selector';
import {take} from 'rxjs/operators';
import {HideInteractionCardAction, ShowInteractionCardAction} from '../shared/stores/root-store/actions/interaction.action';

@Component({
    selector: 'eocm-api',
    template: ''
})
export class ApiComponent {

    constructor(private store: Store<{ video: VideoState }>) {
        const playerApi = {
            play: () => this.playVideo(),
            pause: () => this.pauseVideo(),
            jumpToScene: (sceneId) => this.jumpToScene(sceneId),
            jumpToTime: (time) => this.jumpToTime(time),
            showCard: (cardId) => this.showInteractionCard(cardId),
            hideCards: () => this.hideInteractionCards()
        };

        (window as any).EOCM = {
            video: {
                playerApi
            }
        };
    }

    private playVideo(): void {
        this.store.dispatch(SetVideoStateTypeAction({
            videoState: VideoStateEnum.Playing
        }));
    }

    private pauseVideo(): void {
        this.store.dispatch(SetVideoStateTypeAction({
            videoState: VideoStateEnum.UserPause
        }));
    }

    private jumpToScene(sceneId: number) {
        this.store.pipe(select(selectVideoScenesData)).pipe(take(1)).subscribe(scenes => {
            if (!scenes[sceneId]) {
                console.error('Scene not found');

                return false;
            }

            this.store.dispatch(JumpToSceneAction({
                navigationTime: scenes[sceneId].time.start,
                videoState: VideoStateEnum.Playing
            }));
        });
    }

    private jumpToTime(time: number) {
        this.store.pipe(select(selectTotalTimeFromState)).pipe(take(1)).subscribe(totalTime => {
            if (time > totalTime || time < 0) {
                console.error('Wrong jump time');

                return false;
            }

            this.store.dispatch(JumpToSceneAction({
                navigationTime: time,
                videoState: VideoStateEnum.Playing
            }));
        });
    }

    private showInteractionCard(id: string) {
        this.store.dispatch(ShowInteractionCardAction({
            id
        }));
    }

    private hideInteractionCards() {
        this.store.dispatch(HideInteractionCardAction({
            id: null
        }));
    }
}
